import { render, staticRenderFns } from "./NoticeMngt.vue?vue&type=template&id=9548dfae"
import script from "./NoticeMngt.vue?vue&type=script&lang=js"
export * from "./NoticeMngt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports